/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { CloseRounded, SearchRounded } from '@mui/icons-material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import React, { useCallback, useEffect, useState } from 'react';
import {
  Avatar,
  Box,
  Checkbox,
  InputAdornment,
  SwipeableDrawer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Switch,
  Typography,
  CircularProgress,
  TableHead,
} from '@mui/material';
import { ChromePicker } from 'react-color';
import { useForm } from 'react-hook-form';
import { stringAvatar } from '../../utils/avatarGenerator';

import {
  Button,
  Container,
  Page,
  Header,
  TabButton,
  TabSelection,
  SectionHeaderDrawer,
  Div,
  Text,
  ContainerUsers,
  TextInformation,
  TitleTable,
  TitleEditBoard,
} from './styles';
import { CardBoardActives } from './CardBoardActives';

import {
  Board,
  BoardMember,
  createBoardRequest,
  getActiveBoardsByCompanyId,
  getArchiveBoardsByCompanyId,
  getUsersByCompanyIdRequest,
} from '../../services/requests';
import { CardBoardArchived } from './CardBoardArchived';
import { Input } from '../../components/Input';
import { MemberToSelect } from './BoardDetails';
import useAuthStore from '../../store/auth';
import useCompanyStore from '../../store/companies';
import { InfoCard } from '../../components/InfoCard';
import { LoadingBackdrop } from '../../components/LoadingBackdrop';

export function Boards() {
  const user = useAuthStore(state => state.user);
  const selectedCompany = useCompanyStore(state => state.selectedCompany);

  const [backdropLoading, setBackdropLoading] = useState({
    status: true,
    text: 'Carregando informações dos boards',
  });
  const [listagemActivesBoards, setListagemActivesBoards] = useState<Board[]>(
    [],
  );
  const [listagemArchiveBoards, setListagemArchiveBoards] = useState<Board[]>(
    [],
  );
  const [listaMembros, setListaMembros] = useState<BoardMember[] | undefined>(
    [],
  );
  const [listaUsuarios, setListaUsuarios] = useState<MemberToSelect[]>([]);
  const [listUsersFiltered, setListUsersFiltered] = useState<MemberToSelect[]>(
    [],
  );
  const [selected, setSelected] = React.useState<readonly string[]>([]);
  const [searchForBoards, setSearchForBoards] = useState('');
  const [searchForUsers, setSearchForUsers] = useState('');
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [colorBoard, setColorBoard] = useState('#230674');
  const [page, setPage] = React.useState(0);
  const [openColor, setOpenColor] = useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [statusBoard, setStatusBoard] = useState('ativos');
  const [openDrawerCriarBoard, setOpenDrawerCriarBoard] = useState(false);
  const [dense, setDense] = React.useState(false);
  const [selectedAll, setSelectedAll] = useState<boolean | null>(null);
  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  // const user = selectedCompany?.users?.find(u => u?.id === user?.id);

  // console.log(user, 'USER AQUI');

  const formValidation = useCallback((): any => {
    return Yup.object().shape({
      title: Yup.string()
        .min(3, 'Mínimo 3 caracteres')
        .max(50, 'Máximo 50 caracteres')
        .required('O título é obrigatório.'),
      description: Yup.string().nullable(),
    });
  }, []);

  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm({
    resolver: yupResolver(formValidation()),
  });

  const loadUsers = useCallback(async () => {
    try {
      setBackdropLoading({
        status: true,
        text: 'Carregando informações dos boards',
      });
      const response = await getUsersByCompanyIdRequest(
        selectedCompany?.id as string,
        searchForUsers,
        '',
        '100',
        '',
      );

      if (response?.data.length > 0) {
        const members = response?.data?.data?.map((u: BoardMember) => ({
          ...u,
          profile: 'BMS2',
          selected: false,
        }));

        const usersFiltered = members?.filter(
          (userF: any) => userF.id !== user?.id,
        );
        setListaUsuarios(usersFiltered);
        setListUsersFiltered(usersFiltered);
      }
    } catch (err) {
      console.log(err);
    }
  }, [searchForUsers, selectedCompany?.id, user?.id]);

  useEffect(() => {
    if (selectedCompany) {
      loadUsers();
    }
  }, [selectedCompany]);

  useEffect(() => {
    const filterUser = listaUsuarios?.filter(users =>
      users.name.toUpperCase().includes(searchForUsers.toUpperCase()),
    );
    setListUsersFiltered(filterUser);
  }, [searchForUsers, openDrawerCriarBoard]);

  async function loadBoardsActive() {
    try {
      setBackdropLoading({
        status: true,
        text: 'Carregando informações dos boards',
      });
      const responseActives = await getActiveBoardsByCompanyId(
        selectedCompany?.id as string,
        searchForBoards,
        user?.id as string,
      );

      if (responseActives?.status === 200) {
        setListagemActivesBoards(responseActives?.data);
      }
    } catch (error) {
      console.error('Error LoadBoardsActive', error);
    } finally {
      setBackdropLoading({
        status: false,
        text: 'Carregando informações dos boards',
      });
    }
  }

  async function loadBoardsArchive() {
    try {
      setBackdropLoading({
        status: true,
        text: 'Carregando informações dos boards',
      });
      const responseArchives = await getArchiveBoardsByCompanyId(
        selectedCompany?.id as string,
        searchForBoards,
        user?.id as string,
      );

      setListagemArchiveBoards(responseArchives);
    } catch (err) {
      console.log(err);
    } finally {
      setBackdropLoading({
        status: false,
        text: 'Carregando informações dos boards',
      });
    }
  }

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    setBackdropLoading({
      status: true,
      text: 'Carregando informações dos boards',
    });
    if (selectedCompany) {
      const delayDebounceFn = setTimeout(() => {
        loadBoardsArchive();
        loadBoardsActive();
      }, 600);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchForBoards]);

  const isSelected = (name: string) => selected.indexOf(name) !== -1;
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - listaUsuarios.length) : 0;

  const handleCreateBoard = useCallback(
    async (formData: any) => {
      if (user?.profile === 'UN1' || user?.profile === 'UN2') {
        setBackdropLoading({
          status: true,
          text: 'Criando Board',
        });
        try {
          const members = listaMembros?.map(m => ({
            id: m.id,
            name: m.name,
            email: m.email,
            profile: m.profile,
            status: m.status,
            avatar_url: m.avatar_url,
          }));

          const owner = {
            id: user?.id as string,
            name: user?.name as string,
            email: user?.email as string,
            profile: 'BMS1' as 'BMS2' | 'BMS1',
            status: user?.status as 'US1' | 'US2' | 'US3',
            avatar_url: user?.avatar_url,
          };

          members?.push(owner);

          const board = {
            title: formData.title,
            description: formData.description,
            color: colorBoard,
            members,
            company_id: selectedCompany?.id,
          };

          const response = await createBoardRequest(
            board as any,
            user?.id as string,
            selectedCompany?.id as string,
          );

          if (response?.status === 201) {
            const newBoard = response?.data;

            setListagemActivesBoards([...listagemActivesBoards, newBoard]);
            setColorBoard('#230674');
            reset();
            loadUsers();
            setOpenDrawerCriarBoard(false);
          }
        } catch (error) {
          console.log({ error });
        } finally {
          setBackdropLoading({
            status: false,
            text: 'Carregando informações dos boards',
          });
        }
      } else {
        toast.warning('Você não tem permissão para criar um board');
      }
    },
    [
      user,
      listaMembros,
      colorBoard,
      selectedCompany?.id,
      listagemActivesBoards,
      reset,
      loadUsers,
    ],
  );

  const handleUserToInvite = useCallback(
    (
      event: React.MouseEvent<unknown>,
      name: string,
      usr: MemberToSelect,
      idx: number,
      type: 'select' | 'profile',
    ) => {
      let listaUsuariosEditada = { ...usr };

      if (type === 'select') {
        listaUsuariosEditada.selected = !usr?.selected;
      }

      if (type === 'profile') {
        listaUsuariosEditada.profile =
          usr?.profile === 'BMS1' ? 'BMS2' : 'BMS1';
      }

      if (searchForUsers.length > 0) {
        const listFilteredWhenSearching = listaUsuarios?.map(u => {
          if (u?.id === usr?.id) {
            setSearchForUsers('');

            return listaUsuariosEditada;
          }

          return u;
        });
        const usuariosMembros = listFilteredWhenSearching?.filter(
          u => u.selected,
        );
        setListaMembros([...usuariosMembros!]);
        setListaUsuarios(listFilteredWhenSearching);
        setListUsersFiltered(listFilteredWhenSearching);
      } else {
        listaUsuarios?.splice(idx, 1, listaUsuariosEditada);
        listUsersFiltered?.splice(idx, 1, listaUsuariosEditada);
        setListUsersFiltered([...listUsersFiltered!]);
        setListaUsuarios([...listaUsuarios!]);
        const usuariosMembros = listaUsuarios?.filter(u => u.selected);
        setListaMembros([...usuariosMembros!]);
      }
    },
    [listUsersFiltered, listaUsuarios, searchForUsers.length],
  );

  const handleSelectAllClick = () => {
    setSelectedAll(prev => !prev);
  };

  useEffect(() => {
    if (selectedAll === null) {
      const users = listUsersFiltered?.map(u => ({
        ...u,
      }));
      setListUsersFiltered([...users]);
      setListaUsuarios([...users]);
      setListaMembros([...users]);
    } else if (selectedAll === false) {
      const usersUnselected = listUsersFiltered?.map(u => ({
        ...u,
        selected: false,
      }));
      setListUsersFiltered([...usersUnselected]);
      setListaUsuarios([...usersUnselected]);
      setListaMembros([]);
    } else if (selectedAll === true) {
      const usersSelected = listUsersFiltered?.map(u => ({
        ...u,
        selected: true,
      }));
      setListUsersFiltered([...usersSelected]);
      setListaUsuarios([...usersSelected]);
      setListaMembros([...usersSelected]);
    }
  }, [selectedAll]);

  // const idBoard = params?.id;

  // async function handleBoard(formData: any) {
  //   const idBoard = params?.id;
  //   try {
  //     const board = {
  //       title: formData.title,
  //       description: formData.title,
  //     };

  //     let response: any;

  //     if (idBoard) {
  //       response = await updateBoardRequest(board, idBoard);
  //     } else {
  //       response = await createBoardRequest(board);
  //     }

  //     if (response?.status === 201) {
  //       const newBoard = response?.data;

  //       setListagemActivesBoards([...listagemActivesBoards, newBoard]);
  //     }
  //   } catch (error) {
  //     console.log({ error });
  //   }
  // }

  const drawerBoard = () => (
    <Box
      sx={{
        width: '960px',
        height: '100%',
        padding: '20px',
        position: 'relative',
      }}
    >
      <SectionHeaderDrawer>
        <CloseRounded
          sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
          onClick={() => setOpenDrawerCriarBoard(false)}
        />
        <TitleEditBoard className="title">Criar Board</TitleEditBoard>
      </SectionHeaderDrawer>
      <Box sx={{ marginTop: '20px' }}>
        <form onSubmit={handleSubmit(handleCreateBoard)}>
          <Input
            name="title"
            label="Nome do Board"
            required
            control={control}
            type="text"
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {openColor ? (
                    <div style={{ zIndex: '2' }}>
                      <div
                        style={{
                          position: 'fixed',
                          top: '0px',
                          right: '0px',
                          bottom: '0px',
                          left: '0px',
                        }}
                        onClick={() => setOpenColor(false)}
                      />
                      <ChromePicker
                        color={colorBoard}
                        onChange={(e: any) => setColorBoard(e.hex)}
                      />
                    </div>
                  ) : (
                    <button
                      onClick={() => setOpenColor(true)}
                      style={{
                        backgroundColor: colorBoard,
                        width: '13px',
                        height: '13px',
                        borderRadius: '50%',
                        border: 0,
                      }}
                      type="button"
                      title=""
                    />
                  )}
                </InputAdornment>
              ),
            }}
          />
          <Input
            name="description"
            label="Descrição do Board"
            control={control}
            type="text"
            fullWidth
          />

          <Div>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              width="100%"
              justifyContent="space-between"
            >
              <TitleEditBoard className="title-members">
                Gerencie os membros do board
              </TitleEditBoard>
              <Typography className="title-select">
                {`Selecionados (${
                  listaUsuarios?.filter(u => u.selected === true).length
                })`}
              </Typography>
            </Box>
            <TextInformation>
              Você será adicionado automaticamente como Administrador do Board
            </TextInformation>
            <TextField
              fullWidth
              value={searchForUsers}
              onChange={ev => setSearchForUsers(ev.target.value)}
              variant="filled"
              placeholder="Filtrar usuário..."
              sx={{
                background: '#ffffff',
              }}
              InputProps={{
                endAdornment: <SearchRounded />,
              }}
            />

            {listUsersFiltered && listUsersFiltered?.length > 0 ? (
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
              >
                <TitleEditBoard className="header-table">Nome</TitleEditBoard>
                <TitleEditBoard className="header-table">Admin</TitleEditBoard>
              </Box>
            ) : (
              <Box mt="8vh">
                <InfoCard title="Nenhum usuário encontrado" type="info" />
              </Box>
            )}
          </Div>
          {listUsersFiltered &&
            listUsersFiltered?.length > 0 &&
            (loadingUsers ? (
              <Box
                mt="8vh"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <CircularProgress />
              </Box>
            ) : (
              <Box>
                <ContainerUsers>
                  <Table sx={{ width: '100%' }} aria-labelledby="tableTitle">
                    <TableHead>
                      <TableRow
                        hover
                        sx={{ cursor: 'pointer' }}
                        selected={selectedAll || false}
                        onClick={handleSelectAllClick}
                      >
                        <TableCell
                          padding="checkbox"
                          onClick={handleSelectAllClick}
                        >
                          <Checkbox
                            color="primary"
                            checked={selectedAll || false}
                            onClick={handleSelectAllClick}
                          />
                        </TableCell>
                        <TableCell width="100%">Selecionar todos</TableCell>
                        <TableCell />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listUsersFiltered
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.name);
                          const labelId = `enhanced-table-checkbox-${index}`;

                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              aria-checked={isItemSelected}
                              tabIndex={-1}
                              key={row.name}
                              selected={row.selected}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  color="primary"
                                  checked={row.selected}
                                  onClick={event =>
                                    handleUserToInvite(
                                      event,
                                      row.name,
                                      row,
                                      index,
                                      'select',
                                    )
                                  }
                                  inputProps={{
                                    'aria-labelledby': labelId,
                                  }}
                                />
                              </TableCell>
                              <TableCell
                                component="th"
                                id={labelId}
                                // scope="row"
                                sx={{ padding: '10px', width: '100%' }}
                                onClick={event =>
                                  handleUserToInvite(
                                    event,
                                    row.name,
                                    row,
                                    index,
                                    'select',
                                  )
                                }
                              >
                                <Box
                                  display="flex"
                                  flexDirection="row"
                                  alignItems="center"
                                  gap="20px"
                                >
                                  {row?.avatar_url ? (
                                    <Avatar sx={{ width: '40px' }}>
                                      <img
                                        src={row?.avatar_url as string}
                                        alt="Foto de perfil"
                                        style={{ width: '100%' }}
                                      />
                                    </Avatar>
                                  ) : (
                                    <Avatar
                                      {...stringAvatar(row.name!)}
                                      sx={{ width: '40px' }}
                                    />
                                  )}
                                  <Text fontSize="15px" fontWeight="600">
                                    {row.name}
                                  </Text>
                                </Box>
                              </TableCell>
                              <TableCell
                                component="th"
                                id={labelId}
                                scope="row"
                                sx={{ padding: '10px 0px 10px 10px' }}
                              >
                                {row.selected ? (
                                  <Switch
                                    {...label}
                                    sx={{ paddingRight: '10px' }}
                                    checked={row.profile === 'BMS1'}
                                    onClick={event =>
                                      handleUserToInvite(
                                        event,
                                        row.name,
                                        row,
                                        index,
                                        'profile',
                                      )
                                    }
                                  />
                                ) : (
                                  <Switch
                                    {...label}
                                    sx={{ paddingRight: '10px' }}
                                    disabled
                                    onClick={event =>
                                      handleUserToInvite(
                                        event,
                                        row.name,
                                        row,
                                        index,
                                        'profile',
                                      )
                                    }
                                  />
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: (dense ? 33 : 53) * emptyRows,
                          }}
                        >
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </ContainerUsers>
                {/* <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={listaUsuarios.length}
              rowsPerPage={rowsPerPage}
              labelRowsPerPage="Linhas por página"
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}
              </Box>
            ))}

          <Button
            variant="contained"
            color="success"
            type="submit"
            disabled={isSubmitting}
            sx={{
              color: '#ffffff',
              position: 'absolute',
              fontSize: '15px',
              fontWeight: '500',
              right: '20px',
              bottom: '20px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '6px 16px 6px 12px',
              gap: '8px',
              width: '202px',
              height: '40px',
              borderRadius: '4px',
            }}
          >
            Salvar Alterações
          </Button>
        </form>
      </Box>
    </Box>
  );

  return (
    <Container>
      {backdropLoading.status && (
        <LoadingBackdrop
          text={backdropLoading.text}
          component=""
          loading={backdropLoading.status}
        />
      )}
      <Header>
        <TabSelection>
          <TabButton
            active={statusBoard === 'ativos'}
            onClick={() => setStatusBoard('ativos')}
          >
            ATIVOS
          </TabButton>
          <TabButton
            active={statusBoard === 'arquivados'}
            onClick={() => setStatusBoard('arquivados')}
          >
            ARQUIVADOS
          </TabButton>
        </TabSelection>
        <TextField
          fullWidth
          value={searchForBoards}
          onChange={ev => setSearchForBoards(ev.target.value)}
          placeholder="Pesquisar por Board"
          variant="standard"
          sx={{
            background: '#FFFFFF',
            borderRadius: '4px',
            padding: '9px 12px',
          }}
          InputProps={{
            endAdornment: <SearchRounded />,
            disableUnderline: true, //
          }}
        />
        <React.Fragment key="right">
          <Button
            variant="contained"
            sx={{
              minWidth: '140px',
              width: '175px',
              height: '48px',
              padding: '6px 22px',
              fontWeight: '500',
              lineHeight: '14px',
              whiteSpace: 'nowrap',
              fontSize: '14px',
            }}
            onClick={() => setOpenDrawerCriarBoard(true)}
            disabled={user?.profile !== 'UN2' && user?.profile !== 'UN1'}
          >
            Criar Board
          </Button>
        </React.Fragment>
        <SwipeableDrawer
          className="drawer"
          anchor="right"
          onClose={() => setOpenDrawerCriarBoard(false)}
          onOpen={() => setOpenDrawerCriarBoard(true)}
          open={openDrawerCriarBoard}
          ModalProps={{
            keepMounted: true,
          }}
        >
          {drawerBoard()}
        </SwipeableDrawer>
      </Header>

      <TitleTable>Boards</TitleTable>
      {!backdropLoading.status && (
        <Page>
          {statusBoard === 'ativos' ? (
            <CardBoardActives
              boardsActives={listagemActivesBoards}
              setBoardArchives={setListagemArchiveBoards}
              loading={backdropLoading.status}
            />
          ) : (
            <CardBoardArchived
              boardArchives={listagemArchiveBoards}
              loading={backdropLoading.status}
            />
          )}
        </Page>
      )}
    </Container>
  );
}
